"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const HashLoader_1 = __importDefault(require("react-spinners/HashLoader"));
const InterviewContext_1 = require("../../../contexts/InterviewContext");
const InputString_1 = __importDefault(require("chaire-lib-frontend/lib/components/input/InputString"));
const react_router_1 = require("react-router");
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const LoaderComponent = () => react_1.default.createElement(HashLoader_1.default, { size: 30, color: '#aaaaaa', loading: true });
const InterviewsComponent = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./InterviewSearchList'))));
const InterviewsByAccessCode = () => {
    const location = (0, react_router_1.useLocation)();
    const params = (0, react_router_1.useParams)();
    const { t } = (0, react_i18next_1.useTranslation)('admin');
    const urlSearch = new URLSearchParams(location.search);
    const [currentCode, setCurrentCode] = react_1.default.useState(params.accessCode);
    const [createNewIfNoData] = react_1.default.useState((0, LodashExtensions_1._booleish)(urlSearch.get('autoCreate')) === true);
    const { state, dispatch } = react_1.default.useContext(InterviewContext_1.InterviewContext);
    react_1.default.useEffect(() => {
        if (params.accessCode !== state.response.accessCode) {
            dispatch({ type: 'update_response', response: { accessCode: params.accessCode } });
        }
    }, [params.accessCode, state.response]);
    return (react_1.default.createElement("div", { className: "admin" },
        react_1.default.createElement("div", { className: "survey-section__content apptr__form-container" },
            react_1.default.createElement(InputString_1.default, { id: "accessCodeSearchInput", value: currentCode, onValueUpdated: (newValue) => setCurrentCode(newValue.value) }),
            react_1.default.createElement(react_router_1.Link, { to: `/interviews/byCode/${currentCode}` },
                react_1.default.createElement("button", { type: "button", className: 'survey-section__button button blue small' }, t('admin:interviewSearch:SearchByCode')))),
        react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(LoaderComponent, null) },
            react_1.default.createElement(InterviewsComponent, { autoCreateIfNoData: createNewIfNoData, queryData: urlSearch }))));
};
exports.default = InterviewsByAccessCode;
//# sourceMappingURL=InterviewsByAccessCode.js.map